import MDinput from '@/components/MDinput';
import DateTimePicker from '@/components/DSE/DateTimePicker';

export function getFormDefinition(vue) {
  const validateRequire = function(rule, value, callback) {
    if (!value) {
      callback(new Error(vue.$i18n.t('validation.required')));
    } else {
      callback();
    }
  };
  return {
    id: {
      type: null,
      defaultValue: undefined
    },
    code: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 255,
        disabled: true,
        required: true,
        caption: 'configuration.code'
      },
      rules: [
        {
          validator: validateRequire
        }
      ]
    },
    description: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 255,
        required: true,
        disabled: true
      },
      rules: [
        {
          validator: validateRequire
        }
      ]
    },
    value: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 255,
        caption: 'configuration.value'
      }
    },
    fromDate: {
      type: DateTimePicker,
      defaultValue: '',
      props: {
        caption: 'configuration.fromDate',
        type: 'datetime',
        format: vue.$store.getters.dateTimeFormat
      }
    }
  };
}
export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
